// extracted by mini-css-extract-plugin
export default {"playerSettingsModal":"PlayerSettingsModal_playerSettingsModal__L1D-B","qualityContainer":"PlayerSettingsModal_qualityContainer__7DUYh"};